import { useState } from 'react';
import volks from '../assets/volks.webp'
import jenda from '../assets/jenda.png'
import kalyani1 from '../assets/kalyani1.png'
import kalyani2 from '../assets/kalyani2.png'
import lg from '../assets/LG.png'
import datafeeds from '../assets/Gdatafeeds.png'
import ionisation from '../assets/ionisation.png'
import sibm from '../assets/sibm.png'
import skoda from '../assets/skoda.png'
import premium from '../assets/premium.png'
import tain from '../assets/tain.png'

const LogoTicker = () => {
  const [isHovered, setIsHovered] = useState(false);

  const clientLogos = [
    { src: volks, alt: 'Volkswagen' },
    { src: jenda, alt: 'Jenda' },
    { src: kalyani1, alt: 'Kalyani Group' },
    { src: kalyani2, alt: 'Kalyani' },
    { src: lg, alt: 'LG' },
    { src: datafeeds, alt: 'GDatafeeds' },
    { src: ionisation, alt: 'Ionisation' },
    { src: sibm, alt: 'SIBM' },
    { src: skoda, alt: 'Skoda' },
    { src: premium, alt: 'Premium' },
    { src: tain, alt: 'Tain' }
  ];

  // Duplicate for seamless loop
  const track = [...clientLogos, ...clientLogos];

  return (
    <section className="relative bg-white py-20">
      {/* Section Header */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 mb-10 text-center">
        <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium text-blue-700 bg-blue-50 rounded-full">
          Trusted by
        </span>
        <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">Our Trusted Clients</h2>
        <p className="mt-3 max-w-2xl mx-auto text-lg text-gray-600">
          Teams at leading organizations rely on us for training and enablement
        </p>
      </div>

      {/* Sleek Continuous Carousel */}
      <div className="relative">
        {/* Soft background accents */}
        <div className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute -top-16 left-1/4 h-48 w-48 rounded-full bg-blue-100/50 blur-3xl" />
          <div className="absolute -bottom-16 right-1/4 h-48 w-48 rounded-full bg-sky-100/50 blur-3xl" />
        </div>

        {/* Masked rail */}
        <div
          className="overflow-hidden py-4"
          style={{
            maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
            WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)'
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          aria-label="Trusted clients logos carousel"
        >
          <div
            className={`flex items-center gap-12 animate-scroll-left`}
            style={{ width: 'fit-content', animationPlayState: isHovered ? 'paused' : 'running' }}
          >
            {track.map((logo, idx) => (
              <div
                key={`${logo.alt}-${idx}`}
                className="group flex h-20 items-center rounded-xl border border-gray-100/80 bg-white/70 px-6 shadow-sm backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-10 w-auto max-w-[140px] object-contain filter grayscale opacity-70 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoTicker;